import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" I'm delighted that you've chosen to purchase a book. I expect that you will enjoy reading the book as much as I have enjoyed writing it. ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Laurie ")
const _hoisted_3 = { class: "flex flex-row flex-auto text-black" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-red-500" }, "Please fill in your contact information", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-lg p-2" }, " Payments are secured, encrypted, and processed by PayPal. We never see your payment details. ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "w-1/2 m-auto" }, [
  /*#__PURE__*/_createVNode("div", { class: "bg-gray-100 p-4" }, [
    /*#__PURE__*/_createVNode("div", { id: "paypal-buttons" })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-lg p-8" }, [
  /*#__PURE__*/_createVNode("p", null, "Troubles making your purchase?"),
  /*#__PURE__*/_createVNode("ul", { class: "list-disc" }, [
    /*#__PURE__*/_createVNode("li", null, " If you see a blank Paypal window, something went wrong with your order. Close paypal window and try again. "),
    /*#__PURE__*/_createVNode("li", null, " If you're paying by credit card, scroll up to see if there is a message from paypal. Check your address information, and try again "),
    /*#__PURE__*/_createVNode("li", null, "Contact Laurie directly at kimtuck@comcast.net.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quote = _resolveComponent("quote")
  const _component_pricing_new = _resolveComponent("pricing-new")
  const _component_purchase_form_new_order_details_container = _resolveComponent("purchase-form-new-order-details-container")
  const _component_order_form_new_container = _resolveComponent("order-form-new-container")
  const _component_box = _resolveComponent("box")
  const _component_amazon_purchase = _resolveComponent("amazon-purchase")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_quote, null, {
      quote: _withCtx(() => [
        _hoisted_1
      ]),
      cite: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_pricing_new, { "order-details": _ctx.orderDetails }, null, 8, ["order-details"]),
        _createVNode(_component_purchase_form_new_order_details_container, {
          "order-details": _ctx.orderDetails,
          "onUpdate:orderDetailItem": _ctx.updateOrderDetailItem,
          "onUpdate:orderQuantity": _ctx.updateOrderQuantity
        }, null, 8, ["order-details", "onUpdate:orderDetailItem", "onUpdate:orderQuantity"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_order_form_new_container),
        (_ctx.showCompleteFormMsg)
          ? (_openBlock(), _createBlock(_component_box, {
              key: 0,
              class: "m-4 p-2",
              type: "alert",
              label: "Contact/Shipping information is incomplete"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_box, {
          class: "m-4 p-2 bg-red-100",
          label: "Payment"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_amazon_purchase)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}